export type * from '../../shared/types';

export const VW = 1400;
export const NODE_W = 200;
export const NODE_H = 64;
export const GAP = 40;
export const PAD_TOP = 90;
export const PAD_BOTTOM = 60;
